<template>
  <vue-apex-charts
    type="radialBar"
    height="215"
    :options="chartOptions"
    :series="series"
  />
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'GraficoMeiaRosca',
  components: {
    VueApexCharts,
  },
  props: {
    valor: {
      type: Number,
      required: true,
    },
    color: {
      type: String,
      default: () => 'rgba(95, 173, 86)',
    },
  },
  data() {
    return {
      series: [this.valor],
      chartOptions: {
        chart: {
          type: 'radialBar',
          height: 215,
          offsetY: -20,
          sparkline: {
            enabled: true,
          },
        },
        colors: [this.color],
        plotOptions: {
          radialBar: {
            startAngle: -90,
            endAngle: 90,
            track: {
              background: getComputedStyle(document.documentElement).getPropertyValue('--chart-track-bg').trim() || '#e7e7e7',
              strokeWidth: '97%',
              margin: 5,
            },
            dataLabels: {
              name: {
                show: false,
              },
              value: {
                offsetY: -2,
                fontSize: '22px',
                color: getComputedStyle(document.documentElement).getPropertyValue('--chart-text-color').trim() || '#6e6b7b',
              },
            },
          },
        },
      },
    }
  },
}
</script>
